import { AdditionalIcon } from '../shared/additionalIcon/additionalIcon';
import { FilterMenuItemFieldProps } from './types/filterMenuItemFieldProps';
import UseDebounce from '../../helpers/debounce';
import './filterMenuItemField.scss';
import { useEffect, useState } from 'react';

const FilterMenuText = (props: FilterMenuItemFieldProps) => {
    const [text, setText] = useState<string>();

    useEffect(() => {
        if (props.active) {
            props.onChange(text);
        } else {
            props.onChange(null);
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.active])
    
    const handleChange = (e: any) => {
        setText(e.target.value);
        if (props.active) {
            props.onChange(e.target.value);
        }
    }

    return (<div className="filter-menu-item">
        <label htmlFor={props.id} >
            <div className="body-txt-medium filter-menu-item-label">{AdditionalIcon(props.additionalIcon)} {props.label}</div>
            <input id={props.id} className="body-txt-small" placeholder={props.placeholder} onChange={UseDebounce(handleChange, 500)} />
        </label>
    </div>)
}

export default FilterMenuText;